import styled from 'styled-components'

export const StyledConfirmationHeader = styled.p({
  marginBottom: '1.5rem !important'
})
